import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/produccion/devolucionCajas';
import Devolucion from './DevolucionList';

const ms2p = (state) => {
  return {
    ...state.devolucion_cajas,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Devolucion);
